import styled from 'styled-components'
import { Box } from '~/components/Box'

export const StyledStakingPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.bgBase};

  p {
    margin: 0;
  }
`

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 68px;
  padding: 0 16px;

  ${({ theme }) => theme.media.sm`
    margin-top: 20px;
  `}
`

export const StyledContainerWithChart = styled.div`
  position: relative;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  max-width: 1200px;

  ${({ theme }) => theme.media.sm`
    gap: 0;
  `}
`

export const StyledContainer = styled.div`
  ${({ theme }) => theme.media.sm`
    width: 100%;
  `}
`

export const StyledStakingBox = styled(Box)`
  width: 100%;
  height: 100%;
`

export const StyledMainArea = styled.div`
  position: relative;
  margin-top: 20px;
`

export const StyledStakingCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`

export const StyledStakingHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  > div:first-child {
    display: flex;
    align-items: center;
    gap: 12px;
  }
`

export const StyledStakingIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .eth-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const StyledStakingTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textTitle};
  margin: 0;
`

export const StyledStakingSubtitle = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textCaption};
  margin: 4px 0 0 0;
`

export const StyledBrandLabel = styled.div`
  display: flex;
  align-items: center;

  span {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: #7f8294;
    margin-right: 12px;
  }
`

export const StyledMyRewardSection = styled.div`
  padding-top: 16px;
  border-top: 0.5px solid #dee2ff;
`

export const StyledMyRewardHeader = styled.div`
  display: flex;
  align-items: center;
`

export const StyledMyRewardTitle = styled.h3`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textCaption};
  margin: 0;
  margin-right: 6px;
`

export const StyledMyRewardAmount = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textTitle};
  margin: 6px 0 4px 0;
`

export const StyledMyRewardValue = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textTitle};
`

export const StyledProjectList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`

export const StyledProjectCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px 12px;
  background: ${({ theme }) => theme.colors.bgSurface};
  border-radius: 16px;
  width: 100%;
`

export const StyledProjectHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledProjectTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const StyledProjectTitle = styled.h2`
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  color: #222226;
  margin: 0;
`

export const StyledProjectStats = styled.div`
  display: flex;
  justify-content: space-between;
`

export const StyledStatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const StyledStatLabel = styled.div`
  width: 100%;
  margin-bottom: 4px;
  color: ${({ theme }) => theme.colors.textCaption};
  font-size: 12px;
  font-weight: 500;
  text-align: left;
`

export const StyledStatValue = styled.div<{ color?: 'primary' }>`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme, color }) =>
    color === 'primary' ? theme.colors.primary : theme.colors.textTitle};
`
